import { useApi } from "@appretio/api";
import { useQuery } from "@tanstack/react-query";
import { manageCubesQueryKeys } from "./queryKeys";

/**
 * Fetches available context values for a cube.
 * When filters are provided, returns only values consistent with the
 * current selections (cascading dropdown behavior).
 */
export function useCubeContext(
  cubeId: string | undefined,
  filters?: Record<string, string[]>
) {
  const apiClient = useApi();

  return useQuery({
    queryKey: [...manageCubesQueryKeys.cubeContext(cubeId ?? ""), { filters }],
    meta: {
      errorMessage: "Failed to fetch cube context"
    },
    queryFn: async () => {
      const body: Record<string, unknown> = { cube_id: cubeId! };
      if (filters && Object.keys(filters).length > 0) {
        body.filters = filters;
      }

      const response = await apiClient.POST("/v2/forecast/cubes/context", {
        body: body as { cube_id: string }
      });

      return response.data?.result ?? { options: {} };
    },
    enabled: !!cubeId
  });
}
